<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<caass-schoolselector [ShowAll]="false" [Disabled]="loading || isProcessing" [TableTypeID]="3"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading || isProcessing" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstAllRecords"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSemester"
		dataKey="SemesterID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--Semester-->
				<th>
					<p-columnFilter type="text" field="Semester" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartDate-->
				<th>
					<!-- <p-columnFilter type="text" field="StartDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EndDate-->
				<th>
					<!-- <p-columnFilter type="text" field="EndDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--Save-->
				<th class="ButtonWidth"></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SemesterDesc">Semester<p-sortIcon field="SemesterDesc"></p-sortIcon></th>
				<th pSortableColumn="StartDate">Start Date<p-sortIcon field="StartDate"></p-sortIcon></th>
				<th pSortableColumn="EndDate">End Date<p-sortIcon field="EndDate"></p-sortIcon></th>

				<!--Save-->
				<th class="ButtonWidth"></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Semester>
			<tr>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Semester.SemesterDesc }}
				</td>

				<!--Start Date-->
				<td>
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="Semester.StartDateText"
						name="StartDate"
						(ngModelChange)="onChangeStartDate(Semester)"
						appendTo="body"
					></p-calendar>
				</td>

				<!--End Date-->
				<td>
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="Semester.EndDateText"
						name="EndDate"
						(ngModelChange)="onChangeEndDate(Semester)"
						appendTo="body"
					></p-calendar>
				</td>

				<!--Save-->
				<td class="ButtonWidth">
					<button
						[disabled]="loading || isProcessing"
						*ngIf="!Semester.errorMessage && !Semester.issaving"
						class="btn btn-xs btn-primary"
						type="button"
						(click)="Save(Semester)"
					>
						Save
					</button>
					<span *ngIf="Semester.issaving" style="color: blue"> Please wait! Saving.. </span>
					<span *ngIf="Semester.saved" style="color: green"> Record Saved! </span>
					<span *ngIf="Semester.errorMessage" style="color: red"> {{ Semester.errorMessage }}</span>
				</td>
			</tr>
		</ng-template>
	</p-table>

	<!--Test Validity-->
	<br />
	<button
		name="btnSaving"
		*ngIf="!isProcessing"
		[disabled]="option.schoolID == 0 || loading == true"
		class="btn btn-xs btn-primary"
		type="button"
		(click)="Test()"
	>
		TEST Semester Validity
	</button>
	<span *ngIf="testvalidationpassed" style="color: green"> Period is Valid </span>
	<span *ngIf="testvalidationfailed" style="color: red"> {{ testvalidationerrormessage }}</span>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
